import { Email, EmailSentResponse } from "./types";
import api from "../api";

export async function sendEmail(email: Email): Promise<EmailSentResponse> {
    return new Promise((resolve, reject) => {
        api.post("/support/sendemail", email).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}
